<div class="mb-2">
    <div class="flex w-full flex-row gap-2" [class.items-start]="showAllExpanded" [class.items-center]="!showAllExpanded">
        <span class="shrink-0 whitespace-nowrap text-xs font-semibold leading-5 text-black/70"> {{ categoryLabel }} ({{ chips.length }}): </span>

        <div class="relative min-w-0 flex-1">
            <div class="pointer-events-none invisible absolute -left-[10000px] top-0 flex items-center gap-1.5 whitespace-nowrap" aria-hidden="true">
                <span
                    *ngFor="let chip of chips; trackBy: trackChip"
                    #measureChip
                    class="box-border inline-flex h-5 max-w-full shrink-0 items-center rounded-[10px] py-0 pl-2 pr-1 text-xs leading-none text-darktextcolor"
                    [class.filter-chip-invalid]="chip.isInvalid"
                    [style.background-color]="chip.isInvalid ? null : color"
                >
                    <span class="max-w-[200px] overflow-hidden text-ellipsis whitespace-nowrap">{{ chip.chipLabel }}</span>
                    <span *ngIf="removable" class="inline-block h-5 w-[18px] shrink-0"></span>
                </span>
                <span #moreWidthProbe class="cursor-default whitespace-nowrap px-1.5 text-xs font-semibold leading-5 text-black/60 no-underline">
                    {{ 'GENERAL.LABEL.FILTERS_N_MORE' | translate: { count: moreProbeCount } }}
                </span>
            </div>

            <div #chipTrack class="flex w-full min-h-[20px] items-center gap-1.5" [class.flex-wrap]="showAllExpanded">
                <ng-container *ngFor="let chip of chips; trackBy: trackChip; let i = index">
                    <span
                        *ngIf="showAllExpanded || i < visibleCount"
                        class="box-border inline-flex h-5 max-w-full shrink-0 items-center rounded-[10px] py-0 pl-2 pr-1 text-xs leading-none text-darktextcolor"
                        [class.filter-chip-invalid]="chip.isInvalid"
                        [style.background-color]="chip.isInvalid ? null : color"
                    >
                        <span class="max-w-[200px] overflow-hidden text-ellipsis whitespace-nowrap">{{ chip.chipLabel }}</span>
                        <button
                            *ngIf="removable"
                            type="button"
                            class="filter-chip-remove inline-flex h-5 w-[18px] shrink-0 cursor-pointer items-center justify-center self-center border-0 bg-transparent p-0 leading-none text-black/54 hover:text-darktextcolor"
                            [attr.aria-label]="'GENERAL.BUTTON.REMOVE' | translate"
                            (click)="removeChip.emit(chip)"
                        >
                            <mat-icon>close</mat-icon>
                        </button>
                    </span>
                </ng-container>

                <button
                    *ngIf="!showAllExpanded && hiddenCount > 0"
                    type="button"
                    class="shrink-0 cursor-pointer border-0 bg-transparent px-1 text-xs font-semibold leading-5 text-black/60 underline underline-offset-2 hover:text-darktextcolor"
                    (click)="toggleShowAll()"
                >
                    {{ 'GENERAL.LABEL.FILTERS_N_MORE' | translate: { count: hiddenCount } }}
                </button>

                <button
                    *ngIf="showAllExpanded"
                    type="button"
                    class="shrink-0 cursor-pointer border-0 bg-transparent px-1 text-xs font-semibold leading-5 text-black/60 underline underline-offset-2 hover:text-darktextcolor"
                    (click)="collapseRow()"
                >
                    {{ 'GENERAL.BUTTON.SHOW_LESS' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
